import {DeleteOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {FormListFieldData} from 'antd/es/form/FormList';
import React, {FC} from 'react';

import {fourDigitRule} from '../../utils';

interface IFinancialSourcesYearItemProps {
    field: FormListFieldData;
    onRemove: (index: number) => void;
}

export const FinancialSourcesYearItem: FC<IFinancialSourcesYearItemProps> = ({field, onRemove}: IFinancialSourcesYearItemProps) => (
        <div className="project-item-block">
            <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onRemove(field.name)}
                className="delete-button"
            />
            <div className="form-flex-row">
                <Form.Item
                    name={[field.name, 'finSourceYear']}
                    label="Год финансирования"
                    rules={[
                        fourDigitRule(),
                    ]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={[field.name, 'finSourcePlannedYearSum']}
                    label="	Сумма из источника в году финансирования, руб."
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
            </div>
        </div>
    );


